import { HTTP } from '@/services/axios';

export async function getPhotos({filterText,filterGallery,orderCol,orderSort,page,records}){
    let result = {};
    
    await HTTP.get('/app/core/Photo/getPhotoList.php',{
        params:{
            filterText,
            filterGallery,
            orderCol,
            orderSort,
            page,
            records
        }
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getPhoto({photoId}){
    let result = {};
   
    await HTTP({
        method: 'get',
        url: `/app/core/Photo/getPhotoData.php?photoId=${photoId}`,
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });
    return result;
}
   

export async function getPhotoPreview({photoId}){
    let result = {};
   
    await HTTP({
        method: 'get',
        url: `/app/core/Photo/getPhotoDataPreview.php?photoId=${photoId}`,
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

//nevyuzita TEST dotiahnutia url priamo do src
export async function getPhotoPreviewUrl({photoId}){
    let result = {};
   
    await HTTP({
        method: 'get',
        url: `/app/core/Photo/getPhotoDataPreviewUrl.php?photoId=${photoId}`,
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

//nevyuzita TEST dotiahnutia url priamo do src
export async function getPhotoPreviewUrlThumb({photoId}){
    let result = {};
   
    await HTTP({
        method: 'get',
        url: `/app/core/Photo/getPhotoDataPreviewUrlThumb.php?photoId=${photoId}`,
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getPhotosPreview({photoIds}){
    let result = {};
    
    await HTTP({
        method: 'get',
        url: `/app/core/Photo/getPhotosDataPreview.php?photoIds=${photoIds}`,
    })
    .then(response => {
        console.log(response.data)
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getPhotosPreviewByGallery({galleryId}){
    let result = {};
   
    await HTTP({
        method: 'get',
        url: `/app/core/Photo/getPhotosByGalleryDataPreview.php?galleryId=${galleryId}`
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}


export async function getDataToUploadPhoto({galleryId}){
    let result = {};
   
    await HTTP({
        method: 'get',
        url: `/app/core/Photo/photosUpload/getUploadData.php?galleryId=${galleryId}`
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export function uploadPhotoUrl(){
    return "/app/core/Photo/photosUpload/controlPhotoUpload.php";
}


export async function unlockPhoto({photoId}){
    let result = {};

    var data = {'myRecordID':photoId};
    
    await HTTP({
        method: 'patch',
        url: '/app/core/Photo/controlPhotoUnlock.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function changeStatePhoto({recordId,state}){
    let result = {};

    var data = {'recordId':recordId,'state':state}
    
    await HTTP({
        method: 'patch',
        url: '/app/core/Photo/controlPhotoChangeState.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}


export async function rotatePhoto({photoId}){
    let result = {};

    var data = {'photoId':photoId}
    
    await HTTP({
        method: 'patch',
        url: '/app/core/Photo/controlPhotoRotate.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function savePhoto({data}){
    let result = {};

    await HTTP({
        method: 'put',
        url: '/app/core/Photo/controlPhotoSave.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function deletePhoto({data}){
    let result = {};

    await HTTP({
        method: 'delete',
        url: '/app/core/Photo/controlPhotoDelete.php',
        data: data
    })
    .then(response => {
        console.log(response.data)
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}


//bulk functions


export async function getSelectedPhotos({photoIds}){
    let result = {};
    
    await HTTP.get('/app/core/Photo/deletePhotosBulk/getSelectedData.php',{
        params:{
            photoIDs:photoIds.toString()
        }
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function deletePhotoBulk({photos}){
    let result = {};

    var bodyFormData = new FormData();
	bodyFormData.set('myPhotoIDs',photos);
    
    await HTTP({
        method: 'post',
        url: '/app/core/Photo/deletePhotosBulk/controlDeleteBulkPhotos.php',
        data: bodyFormData
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}